module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/8baf01f898926b892ae95572218743ff.png";